// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.
export const environment = {
  production: false,
  amplitudeKey: '41ae0889d69946c83bc3e52dcbc7ea30',
  sentryDSN:
    'https://44c5078ff5de4ca9b8b05dde15d54abf@o121681.ingest.sentry.io/6506282',
  sentryAuthToken:
    'fc73bc6f01330509328d2782198942b47482d92f121313447b087aa827612951',
  paymentBindingLink: 'https://autopass.test-app.link/uykUvm1Zf1b',
  newPlateLink: 'https://autopass.test-app.link/VgggJl41bZb',
};
